import { FunctionComponent } from 'react'

import { isValidAd } from '@utils/ads'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import Ad from '@components/Ad'

export interface AdRingierProps {
  placement: string
  isAdDisabled?: boolean
  slotCodeDesktop?: string
  slotCodeTablet?: string
  slotCodeMobile?: string
  containerId?: string
  className?: string
}

const AdRingierWidget: FunctionComponent<AdRingierProps> = (props) =>
  props.isAdDisabled !== true && isValidAd(props) ? <Ad {...props} /> : null

const widget = {
  kind: ['ad-ringier'],
  component: AdRingierWidget,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
